// Workstreams Vuex module
import { createBaseModule } from './base'
import { workstreamsApi } from '@/services/api'

const customActions = {
  async fetchAll({ commit }, params = {}) {
    commit('SET_LOADING', true); commit('CLEAR_ERROR')
    try {
      const data = await workstreamsApi.getAll(params)
      const items = Array.isArray(data) ? data : (data?.workstreams || [])
      commit('SET_ITEMS', items)
      return items
    } catch (e) {
      if (e?.response?.status === 403) {
        try {
          const mine = await workstreamsApi.listMine(params)
          const items = Array.isArray(mine) ? mine : []
          commit('SET_ITEMS', items)
          return items
        } catch (_) {
          commit('SET_ITEMS', [])
          return []
        }
      }
      commit('SET_ERROR', e?.message || 'Failed to load workstreams')
      throw e
    } finally {
      commit('SET_LOADING', false)
    }
  },
  async getMembers({ commit }, id) {
    try {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      const res = await workstreamsApi.getMembers(id)
      // API shape: { members: [...] }
      return res?.members || []
    } finally { commit('SET_LOADING', false) }
  },
  async addMember({ commit }, { id, member_id, role = 'contributor' }) {
    try {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      return await workstreamsApi.addMember(id, { member_id, role })
    } finally { commit('SET_LOADING', false) }
  },
  async removeMember({ commit }, { id, memberID }) {
    try {
      commit('SET_LOADING', true); commit('CLEAR_ERROR')
      return await workstreamsApi.removeMember(id, memberID)
    } finally { commit('SET_LOADING', false) }
  },
}

export default createBaseModule('workstream', workstreamsApi, { customActions })
